import React, { useState } from 'react';
import {
  Box,
  Text,
  Button,
  Image,
  Input,
  Select,
  Icon,
} from '@chakra-ui/react';
import { StarIcon } from '@chakra-ui/icons';
import userIcon from '../../../static/assets/images/defaultProfileImage.svg';
import eyeIcon from '../../../static/assets/images/ic_round-visibility.svg';
import sendIcon from '../../../static/assets/images/sendIcon.svg';
import sendIconWhite from '../../../static/assets/images/sendIconWhite.svg';
import usdIcon from '../../../static/assets/images/usdIcon.svg';
import arrowDown from '../../../static/assets/images/arrowDown.svg';
import { theme } from '../../../styles/theme/base';
import footerIcon from '../../../static/assets/images/ic_round-lock(1).svg';
import checkIcon from '../../../static/assets/images/check.svg';
import plusIcon from '../../../static/assets/images/plus.svg';
import rateIcon from '../../../static/assets/images/rateIcon.svg';

export const ResellTabs = () => {
  return <></>;
};

export const SellerComponent = ({
  listing,
  handleClick,
  handleRemove,
  handleViewProof,
  handleViewSeller,
  handleSendListing,
  isInCart,
  disabled,
}) => {
  return (
    <Box
      display="flex"
      height="64px"
      padding="8px"
      justifyContent="space-between"
      alignItems="center"
      alignSelf="stretch"
      borderRadius="40px"
      border="1px solid rgba(255, 255, 255, 0.24)"
      _hover={{ cursor: disabled ? 'not-allowed' : 'pointer' }}
      onClick={!isInCart && !disabled ? handleClick : handleRemove}
      opacity={disabled ? 0.5 : 1}
      pointerEvents={disabled ? 'none' : 'auto'}
    >
      <Box display="flex" alignItems="center" gap="12px" flex="1" minWidth="0">
        <Box
          display="flex"
          width="48px"
          height="48px"
          justifyContent="center"
          alignItems="center"
          flexShrink="0"
          onClick={(e) => {
            e.stopPropagation();
            if (listing.seller) {
              handleViewSeller();
            }
          }}
        >
          <Box
            borderRadius="100px"
            background={`url(${
              listing.seller.image === 'undefined' || !listing.seller.image
                ? userIcon
                : listing.seller.image
            }) lightgray 50% / cover no-repeat`}
            width="48px"
            height="48px"
            flexShrink={0}
          />
        </Box>
        <Box
          display="flex"
          flexDirection="column"
          alignItems="flex-start"
          gap="2px"
          minWidth="0"
          flex="1"
        >
          <Box display="flex" alignItems="baseline" gap="8px" width="100%">
            <Text
              color="#FFF"
              fontFamily="Inter"
              fontSize="18px"
              fontStyle="normal"
              fontWeight="500"
              lineHeight="20px"
            >
              ${Number(listing.price).toFixed(0)}
            </Text>
          </Box>
          <Box display="flex" alignItems="center" gap="3px">
            <Icon
              as={StarIcon}
              w="12px"
              h="12px"
              color="rgba(240, 240, 240, 0.64)"
            />
            <Text
              color="rgba(240, 240, 240, 0.64)"
              fontFamily="Inter"
              fontSize="12px"
              fontStyle="normal"
              fontWeight="400"
              lineHeight="12px"
              marginStart="3px"
              marginBottom="-2px"
            >
              {listing.seller.rating?.toFixed(1) || '5.0'}{' '}
              {listing.seller.firstName}
            </Text>
          </Box>
        </Box>
      </Box>

      <Box
        display="flex"
        alignItems="center"
        gap="16px"
        flexShrink="0"
        maxWidth="144px"
        onClick={(e) => e.stopPropagation()}
      >
        <Button
          display="flex"
          width="40px"
          height="40px"
          padding="0px"
          justifyContent="center"
          alignItems="center"
          borderRadius="100px"
          border="1px solid rgba(255, 255, 255, 0.24)"
          background="rgba(240, 240, 240, 0.04)"
          onClick={handleViewProof}
        >
          <Image src={eyeIcon} alt="Eye Icon" width="18px" height="18px" />
        </Button>
        {!isInCart && (
          <Button
            display="flex"
            width="40px"
            height="40px"
            padding="0px"
            justifyContent="center"
            alignItems="center"
            borderRadius="100px"
            border="1px solid rgba(255, 255, 255, 0.24)"
            background="rgba(240, 240, 240, 0.04)"
            onClick={handleClick}
          >
            <Image src={plusIcon} alt="Plus Icon" width="18px" height="18px" />
          </Button>
        )}
        {isInCart && (
          <Button
            display="flex"
            width="40px"
            height="40px"
            padding="0px"
            justifyContent="center"
            alignItems="center"
            borderRadius="100px"
            border="1px solid rgba(255, 255, 255, 0.24)"
            background="#F0F0F0"
            onClick={handleRemove}
          >
            <Image
              src={checkIcon}
              alt="Check Icon"
              width="18px"
              height="18px"
            />
          </Button>
        )}
      </Box>
    </Box>
  );
};

export const BuyerComponent = ({ handleClick, offer, handleSendOffer }) => {
  return (
    <Box
      display="flex"
      padding="8px 12px 8px 8px"
      justifyContent="space-between"
      alignItems="center"
      alignSelf="stretch"
      borderRadius="40px"
      border="1px solid rgba(255, 255, 255, 0.24)"
    >
      <Box display="flex" alignItems="center" gap="16px" flex="1" minWidth="0">
        <Box
          display="flex"
          width="48px"
          height="48px"
          justifyContent="center"
          alignItems="center"
          flexShrink="0"
        >
          <Box
            borderRadius="var(--Spacing-spacing-none, 48px)"
            background={`url(${
              offer.buyer.image && offer.buyer.image !== ''
                ? offer.buyer.image
                : userIcon
            }) lightgray 50% / cover no-repeat`}
            width="48px"
            height="48px"
            flexShrink="0"
          />
        </Box>
        <Box
          display="flex"
          flexDirection="column"
          alignItems="flex-start"
          gap="2px"
          minWidth="0"
          flex="1"
        >
          <Box display="flex" alignItems="center" gap="8px" width="100%">
            <Box display="flex" alignItems="center" gap="4px" width="100%">
              <Text
                color="#FFF"
                fontFamily="Gordita"
                fontSize="16px"
                fontStyle="normal"
                fontWeight="700"
                lineHeight="132%"
                flexShrink="0"
              >
                ${Number(offer.price * offer.quantity).toFixed(0)}
              </Text>
              <Text
                color="rgba(255, 255, 255, 0.80)"
                fontFamily="Gordita"
                fontSize="16px"
                fontStyle="normal"
                fontWeight="700"
                lineHeight="132%"
                overflow="hidden"
                textOverflow="ellipsis"
                whiteSpace="nowrap"
                flex="1"
              >
                {offer.quantity}x {offer.type}
              </Text>
            </Box>
          </Box>
          <Box display="flex" alignItems="flex-end" gap="4px" width="100%">
            <Text
              color="rgba(255, 255, 255, 0.64)"
              fontFamily="Gordita"
              fontSize="12px"
              fontStyle="normal"
              fontWeight="400"
              lineHeight="124%"
              overflow="hidden"
              textOverflow="ellipsis"
              whiteSpace="nowrap"
              flex="1"
            >
              {offer.buyer.firstName || ''}
            </Text>
          </Box>
        </Box>
      </Box>
      <Box display="flex" alignItems="center" gap="15px" flexShrink="0">
        <Button
          display="flex"
          width="45px"
          height="45px"
          padding="0px 12px"
          justifyContent="center"
          alignItems="center"
          gap="8px"
          borderRadius="100px"
          border="1px solid rgba(255, 255, 255, 0.24)"
          background="transparent"
          onClick={handleSendOffer}
        >
          <Image
            src={sendIconWhite}
            alt="Send Icon"
            width="18px"
            height="18px"
          />
        </Button>
        <Button
          display="flex"
          height="44px"
          minWidth="80px"
          padding="0px 24px"
          justifyContent="center"
          alignItems="center"
          gap="5px"
          borderRadius="40px"
          border="1px solid rgba(255, 255, 255, 0.24)"
          background="#000"
          onClick={handleClick}
        >
          <Text
            color="#FFF"
            textAlign="center"
            fontFamily="Gordita"
            fontSize="16px"
            fontStyle="normal"
            fontWeight="700"
            lineHeight="150%"
          >
            Sell
          </Text>
        </Button>
      </Box>
    </Box>
  );
};

export const PlaceBidSection = ({
  handlePlaceBid,
  isMobile,
  price,
  setPrice,
  quantity,
  setQuantity,
  empty,
}) => {
  return (
    <Box
      position={empty ? 'relative' : 'sticky'}
      marginTop={empty ? '60px' : ''}
      bottom={empty ? '0' : '80px'}
      display="flex"
      justifyContent="center"
      alignItems="center"
      zIndex="99"
      width="100%"
      maxWidth={isMobile ? '100%' : '507px'}
      margin="0 auto"
    >
      <Box
        display="flex"
        height="56px"
        width="100%"
        borderWidth="1px"
        borderRadius="40px"
        borderColor="rgba(240, 240, 240, 0.12)"
        flexDirection="row"
        alignItems="center"
        justifyContent="space-between"
        paddingStart="24px"
        paddingEnd="8px"
        background="rgba(0, 0, 0, 0.8)"
        backdropFilter="blur(10px)"
        boxShadow="0px 4px 24px rgba(0, 0, 0, 0.25)"
      >
        <Text
          color="rgba(240, 240, 240, 0.8)"
          fontSize="14px"
          lineHeight="18px"
          fontFamily="Inter"
          fontWeight="500"
        >
          {empty
            ? 'No tickets currently listed'
            : "Didn't find the right ticket?"}
        </Text>
        <Button
          height="40px"
          minWidth="100px"
          padding="0 24px"
          justifyContent="center"
          alignItems="center"
          gap="5px"
          borderRadius="40px"
          bg="white"
          color="black"
          textAlign="center"
          className="inter-700"
          fontSize="14px"
          fontWeight="700"
          onClick={handlePlaceBid}
        >
          Place a bid!
        </Button>
      </Box>
    </Box>
  );
};

export const SecuredTickets = ({ isMobile }) => {
  return (
    <Box display="flex" alignItems="center" gap="16px" alignSelf="stretch">
      <Box
        display="flex"
        width="48px"
        height="48px"
        justifyContent="center"
        alignItems="center"
        borderRadius="16px"
        background="rgba(255, 255, 255, 0.04)"
      >
        <Image src={footerIcon} width="24px" height="24px" flexShrink={0} />
      </Box>

      <Box
        display="flex"
        flexDirection="column"
        alignItems="flex-start"
        gap="4px"
      >
        <Text
          color="#FFF"
          fontFamily="Gordita"
          fontSize="14px"
          fontWeight={700}
          lineHeight="132%"
        >
          We secure your money till you get your tickets
        </Text>
        <Text
          color="rgba(255, 255, 255, 0.64)"
          fontFamily="Gordita"
          fontSize="12px"
          fontWeight={400}
          lineHeight="150%"
        >
          If you don't get your tickets, we will refund your purchase.
        </Text>
      </Box>
    </Box>
  );
};

export const TicketsSentToAccount = ({ platform }) => {
  return (
    <Box display="flex" alignItems="center" gap="16px" alignSelf="stretch">
      <Box
        display="flex"
        width="48px"
        height="48px"
        justifyContent="center"
        alignItems="center"
        borderRadius="16px"
        background="rgba(255, 255, 255, 0.04)"
      >
        <Image src={sendIcon} width="24px" height="24px" flexShrink={0} />
      </Box>

      <Box
        display="flex"
        flexDirection="column"
        alignItems="flex-start"
        gap="4px"
      >
        <Text
          color="#FFF"
          fontFamily="Gordita"
          fontSize="14px"
          fontWeight={700}
          lineHeight="132%"
        >
          Tickets delivered to your {platform || 'platform'} account or by email
        </Text>
        <Text
          color="rgba(255, 255, 255, 0.64)"
          fontFamily="Gordita"
          fontSize="12px"
          fontWeight={400}
          lineHeight="150%"
        >
          Tickets will be delivered to your {platform || 'platform'} account or
          by email before the event.
        </Text>
      </Box>
    </Box>
  );
};

export const PaymentSentAfterTransfer = ({ isMobile }) => {
  return (
    <Box display="flex" alignItems="center" gap="16px" alignSelf="stretch">
      <Box
        display="flex"
        width="48px"
        height="48px"
        justifyContent="center"
        alignItems="center"
        borderRadius="16px"
        background="rgba(255, 255, 255, 0.04)"
        flexShrink={0}
      >
        <Image src={footerIcon} width="24px" height="24px" flexShrink={0} />
      </Box>

      <Box
        display="flex"
        flexDirection="column"
        alignItems="flex-start"
        gap="4px"
      >
        <Text
          color="#FFF"
          fontFamily="Gordita"
          fontSize="14px"
          fontWeight={700}
          lineHeight="132%"
        >
          Payment will be sent to you after ticket transfer.
        </Text>
        <Text
          color="rgba(255, 255, 255, 0.64)"
          fontFamily="Gordita"
          fontSize="12px"
          fontWeight={400}
          lineHeight="150%"
        >
          We collect the money from the buyer when the tickets are purchased but
          for security reasons, we will send it to you after the ticket
          transfer.
        </Text>
      </Box>
    </Box>
  );
};

export const SecuredPayment = () => {
  return (
    <Box display="flex" alignItems="center" gap="16px" alignSelf="stretch">
      <Box
        display="flex"
        width="48px"
        height="48px"
        justifyContent="center"
        alignItems="center"
        borderRadius="16px"
        background="rgba(255, 255, 255, 0.04)"
      >
        <Image src={footerIcon} width="24px" height="24px" flexShrink={0} />
      </Box>

      <Box
        display="flex"
        flexDirection="column"
        alignItems="flex-start"
        gap="4px"
      >
        <Text
          color="#FFF"
          fontFamily="Gordita"
          fontSize="14px"
          fontWeight={700}
          lineHeight="132%"
        >
          Get securedly paid out via Stripe
        </Text>
      </Box>
    </Box>
  );
};

export const TicketTransfer = () => {
  return (
    <Box display="flex" alignItems="center" gap="16px" alignSelf="stretch">
      <Box
        display="flex"
        width="48px"
        height="48px"
        justifyContent="center"
        alignItems="center"
        borderRadius="16px"
        background="rgba(255, 255, 255, 0.04)"
      >
        <Image src={sendIcon} width="24px" height="24px" flexShrink={0} />
      </Box>

      <Box
        display="flex"
        flexDirection="column"
        alignItems="flex-start"
        gap="4px"
      >
        <Text
          color="#FFF"
          fontFamily="Gordita"
          fontSize="14px"
          fontWeight={700}
          lineHeight="132%"
        >
          Ticket transfer instructions provided to you
        </Text>
      </Box>
    </Box>
  );
};
